module.exports = __webpack_public_path__ + "static/media/social_fb_gray.34b16489.svg";